import { useAuthStore } from "@features/authentication/stores/authStore";
import { useQuery } from "@tanstack/react-query";
import QUERY_KEYS from "../queryKeys";
import sharedService from "../services";

/**
 * Hook to get the current user data from the database.
 * Only fetches when userId is available.
 */
export default function useCurrentUser() {
  const { userId } = useAuthStore();

  const { data: user, ...queryResult } = useQuery({
    queryKey: [QUERY_KEYS.CURRENT_USER, userId],
    queryFn: () => sharedService.getCurrentUser(userId ?? ""),
    enabled: !!userId,
  });

  return { ...queryResult, user };
}
